import { getCurrentInstance, inject, onUnmounted } from "vue";

import { type FormInput } from "shared/components/base/BaseFormWrapper";
import { FormWrapperSymbol } from "shared/components/base/symbols";

export function useFormChild(formChild: FormInput) {
  const Form = inject(FormWrapperSymbol, null);
  const instance = getCurrentInstance();

  if (Form && instance?.proxy) {
    const { proxy } = instance;

    const input: FormInput & typeof proxy = Object.assign(proxy, formChild);

    Form.register(input);

    onUnmounted(() => {
      Form.unregister(input);
    });
  }
}

export default useFormChild;
